import Core from '@plugin_productdetailaction/core';
import Content from '@plugin_productdetailaction/components';

const ProductDetailAction = (props) => <Core {...props} Content={Content} />;

export default ProductDetailAction;
